import { WebCategory } from './grid';

export enum SchedulesMethod {
  READ_RECORDS = 'readRecords',
  CREATE_RECORDS = 'createRecords',
  REMOVE_RECORDS = 'removeRecords',
  UPDATE_RECORDS = 'updateRecords',
  GET_POLICIES_BY_SCHEDULE_ID = 'getPolicyIdsByWacScheduleIdExcludingInheritedSection',
  ASSIGN_SCHEDULE_TO_POLICIES = 'assignToMultiplePolicies',
}

export interface SchedulesResponse {
  success: boolean;
  data: Array<ScheduleItem>;
  total: number;
}

export interface ScheduleItem {
  _id: string;
  name: string;
  company: Company;
  inPoliciesCount?: number;
  allowChangeByOtherUsers: boolean;
  subschedules: Array<SubSchedule>;
  updated?: UpdateInfo,
  created?: UpdateInfo,
}

export interface SubSchedule {
  index?: number;
  name: string;
  action: number;
  allWebsites: boolean;
  categories: Array<WebCategory>;
  enableDetailedAlerts: boolean;
  days: Array<number>;
  timeInterval: TimeInterval
}

export interface TimeInterval {
  startHour: number;
  startMinute: number;
  endHour: number;
  endMinute: number;
}

export interface UpdateInfo {
  date: string;
  userId: string;
  userName: string;
}

export interface Company {
  id: string;
  name?: string;
}

export interface DeleteSchedulesRequestData {
  records: Array<DeleteScheduleItem>;
}

export interface DeleteScheduleItem {
  _id: string;
  company: Company;
}

export interface GetPoliciesByScheduleIdResponse {
  success: boolean;
  data: string[];
}

export interface AssignScheduleToPoliciesResponse {
  success: boolean;
}
